import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { accordionStyles } from './styles';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { UnitsGraphs } from './UnitsGraphs';

export const UnitsAccordion = ({data, unitType, savedData, setSavedData}) => {
  const [open, setOpen] = useState(false)
  const [graphs, setGraphs] = useState(false)
  const classes = accordionStyles();
  const { positive, negative, bgColor, registers } = data

  useEffect(() => {
    let graph
    if(!open) graph = setTimeout(() => setGraphs(false), 400)
    else {
      clearTimeout(graph)
      setGraphs(true)
    }
    return () => {
      clearTimeout(graph)
    }
  }, [open])

  return (
    <React.Fragment key={unitType}>
      <Grid item xs={12} style={{ margin: '0 auto' }}>
        <Card className={`${classes.border} `} sx={{boxShadow: 3}}>                  
          <Accordion style={{backgroundColor: 'rgba(246, 246, 246 ,1)'}}>
            <AccordionSummary
              expandIcon={ <ExpandMoreIcon className={classes.icon} /> }
              className={ `${classes.box} ${classes[bgColor]}` }
              onClick={() => setOpen(!open)}
            >
              <Typography className={classes.heading}>{unitType}</Typography>
              <Box className={classes.text}>
                <Box className={classes.text}>
                  <Typography className={classes.heading}>{positive}</Typography>
                  <CheckCircleIcon className={classes.iconG} />
                </Box>
                <Box className={classes.text}>
                  <CancelIcon className={classes.iconB} />
                  <Typography className={classes.heading}>{negative}</Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {
                graphs && <UnitsGraphs 
                    registers={registers} 
                    unitType={unitType} 
                    savedData={savedData} 
                    setSavedData={setSavedData}
                  />
              }
            </AccordionDetails>
          </Accordion>
        </Card>
      </Grid>
    </React.Fragment>
  )
}
